/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const AdminAdministrationGet = {
  id: 'admin-administration.get',
  tag: 'Admin',
  summary: 'Enquiries',
  description: 'Get all Enquiries',
  method: 'get',
  flags: { isAuthorized: true, isSuperuser: true },
  route: () => `/administration/enquiry`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.array(
            z.strictObject({
              topic: z.string(),
              subject: z.string(),
              message: z.string(),
              createdAt: z.date(),
              user: z.strictObject({
                firstName: z.string(),
                middleName: z.string().nullable().optional(),
                lastName: z.string(),
                email: z.string(),
                ratingLevel: z.string().optional(),
                verified: z.boolean(),
                language: ZodTypes.Language,
              }),
            }),
          ),
        },
      },
    },
  },
} as const satisfies Endpoint;
